import { render, staticRenderFns } from "./SupplierHeaderFieldRecog.vue?vue&type=template&id=0369f386&scoped=true&"
import script from "./SupplierHeaderFieldRecog.vue?vue&type=script&lang=ts&"
export * from "./SupplierHeaderFieldRecog.vue?vue&type=script&lang=ts&"
import style0 from "./SupplierHeaderFieldRecog.vue?vue&type=style&index=0&id=0369f386&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0369f386",
  null
  
)

export default component.exports